import BattedBallType from "../../enums/BattedBallType.js";

const classifiesAsAirBall = function(paResult) {
    switch (paResult) {
        case BattedBallType.FlyBall.key:
        case BattedBallType.LineDrive.key:
        case BattedBallType.PopUp.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsAirBall;